module.exports = __webpack_public_path__ + "static/img/product07-1.8785ecc2.png";